export default {
  PUBLIC: 'PUBLIC',
  PERSONAL: 'PERSONAL',
  HISTORY: 'HISTORY'
}
